import { put, call, takeEvery } from 'redux-saga/effects';
import * as apis from '../../network/apis/settings';
import * as types from './types';
import * as actions from './actions';
import { showErrorMsg, showSuccessMsg } from '../../utils/Helpers';
import { ROUTE_PATHS } from '../../utils/RoutesPaths';
import history from '../../routes/History';

function* getCancellationPolicyConstantsSaga() {
  try {
    const response = yield call(apis.getCancellationPolicyConstants);
    yield put(actions.getCancelationConstantsResponse({
      maxConsecutiveCancellations: response.data.cancellation_policy.max_consecutive_cancellations,
      cancellationPreventionDays: response.data.cancellation_policy.cancellation_prevention_days,
      cancellationCutoffHours : response.data.cancellation_policy.cancellation_cutoff_hours,
      allowConsecutiveCancellations: response.data.cancellation_policy.allow_consecutive_cancellations
    }));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getMimarConstantsSaga() {
  try {
    const response = yield call(apis.getMimarConstants);
    yield put(actions.getMimarConstantsResponse({
      vat: response.data.settlement_constants.vat,
      onlineFees: response.data.settlement_constants.online_fees,
      mimarsCommission : response.data.settlement_constants.mimars_commission,
      fixedFees : response.data.settlement_constants.fixed_fees,
      commissionThreshold : response.data.settlement_constants.commission_threshold,
    }));
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* updateAppConstantsSaga({payload}) {
  try {
    const response = yield call(apis.updateAppConstants, payload.data);
    yield showSuccessMsg('editedSuccessfully');
    if(payload.from === 'cancellationPolicy'){
      yield history.push(ROUTE_PATHS.cancellationPolicy);
    }else{
      yield history.push(ROUTE_PATHS.mimarConstants);
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

export default function* SettingsSagas() {
  yield takeEvery(types.GET_CANCELLATION_POLICY_CONSTANTS_REQUEST, getCancellationPolicyConstantsSaga);
  yield takeEvery(types.GET_MIMAR_CONSTANTS_REQUEST, getMimarConstantsSaga);
  yield takeEvery(types.UPDATE_APP_CONSTANTS, updateAppConstantsSaga);
}